import { render } from "./WebreaderApp.vue?vue&type=template&id=d827e48e"
import script from "./WebreaderApp.js?vue&type=script&lang=js"
export * from "./WebreaderApp.js?vue&type=script&lang=js"

import "./WebreaderApp.vue?vue&type=style&index=0&id=d827e48e&lang=scss"

import exportComponent from "/Users/dservdevel/jenkins_node/workspace/t_ccidist-reader-vue_release_5.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__